export default __webpack_public_path__ + "static/media/phone-cross.95c6f7b7.svg";